const showLocalDate = function (date, separator) {
  const localDate = new Date(date);
  return [localDate.getFullYear(), (localDate.getMonth() + 1).toString().padStart(2, '0'), localDate.getDate().toString().padStart(2, '0')].join(separator);
};

const showLocalDateTime = function (date, separator_date, separator_time) {
  const localDate = new Date(date);
  return [localDate.getFullYear(), (localDate.getMonth() + 1).toString().padStart(2, '0'), localDate.getDate().toString().padStart(2, '0')].join(separator_date) + ' ' + [localDate.getHours().toString().padStart(2, '0') ,localDate.getMinutes().toString().padStart(2, '0')].join(":");
};

export default { showLocalDate, showLocalDateTime };